import React from "react";
import Seo from "../Seo";
import { buildPropertySeo } from "../../../seo/builders/property";

/**
 * PDP SEO.
 */
const PropertyStructuredData = ({ details, images, serverTime, origin }) => {
  const resolvedOrigin =
    origin || (typeof window !== "undefined" ? window.location.origin : "");
  const data = buildPropertySeo(details, images, {
    serverTime,
    origin: resolvedOrigin,
  });
  if (!data) return null;

  return (
    <Seo
      title={data.title}
      description={data.description}
      canonical={data.canonical}
      image={data.ogImage}
      ogType="product"
      jsonLd={data.jsonLd}
      meta={[{ name: "property-data", content: data.metaJson }]}
    />
  );
};

export default PropertyStructuredData;
